module.exports = __webpack_public_path__ + "static/img/materials7.fe84e0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materials7.png
// module id = bl10
// module chunks = 2